// ABOUTME: RTK Query endpoints for persisting user table/grid layout settings to the backend.
// ABOUTME: GET fetches on environment switch; PUT upserts the entire userLayout document.

import { apiSlice } from "../../createApiSlice";

const API_BASE = "/tablesettings";
const buildUrl = (endpoint) => API_BASE + endpoint;

export const tableSettingsSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Fetch the user's saved table settings for the current environment.
         * Called imperatively on every environment switch — uses a mutation
         * so each call gets fresh data without cache key collisions
         * (the environment context comes from request headers, not args).
         */
        getTableSettings: builder.mutation({
            query: () => ({
                url: buildUrl(""),
                method: "GET",
            }),
        }),

        /**
         * Upsert the entire table settings document. The backend creates the
         * record if it doesn't exist yet, otherwise overwrites it.
         * Payload: { columnConfigs, generalSettings, tabConfigs }
         */
        putTableSettings: builder.mutation({
            query: (body) => ({
                url: buildUrl(""),
                method: "PUT",
                body,
            }),
        }),
    }),
});

export const {
    useGetTableSettingsMutation,
    usePutTableSettingsMutation,
} = tableSettingsSlice;
